import React, { useCallback } from "react";

import { connect } from "react-redux";
import { compose } from "redux";

import { logout, updateUserPassword } from "../../actions/auth";
import { editUser } from "../../actions/company/users";
import { loadUser } from "../../actions/user";
import { getNotificationsList, getNotificationsStatus } from "../../actions/ncs/read";
import {
    deleteSingleNotification,
    deleteNotificationsList,
    updateSingleNotification,
    updateNotificationsList
} from "../../actions/ncs/write";

import { resetUserInfo } from "../../actions/user";
import LayoutHeaderComponent from "../../components/manage-data/user/new-user-modal/layout-header-component";
import SuccessPage from "../../components/manage-data/user/new-user-modal/success-page";
import { errorBoundary } from "../../components/general/error-boundary";

const MulticompanyCreateUserSuccessView = ({
    auth,
    logout,
    resetUserInfo,
    user,
    editUser,
    loadUser,
    notificationsExist,
    notificationsList,
    notificationsListStatus,
    deleteSingleNotification,
    deleteNotificationsList,
    getNotificationsList,
    getNotificationsStatus,
    updateSingleNotification,
    updateNotificationsList,
    updateUserPassword,
    updateUserPswStatus,
    userEditStatus
}) => {
    const getNcsNotificationsList = useCallback(() => {
        if (user.user) {
            getNotificationsList(user.user.profile.ncsId);
        }
    }, [getNotificationsList, user]);

    const getNcsNotificationsExist = useCallback(() => {
        if (user.user) {
            getNotificationsStatus(user.user.profile.ncsId);
        }
    }, [getNotificationsStatus, user]);

    return (
        <>
            <LayoutHeaderComponent
                auth={auth}
                user={user}
                logout={logout}
                display={true}
                editUser={editUser}
                loadUser={loadUser}
                notificationsExist={notificationsExist}
                notificationsList={notificationsList}
                notificationsListStatus={notificationsListStatus}
                deleteSingleNotification={notificationId =>
                    deleteSingleNotification(user.user.profile.ncsId, notificationId)
                }
                deleteNotificationsList={() => deleteNotificationsList(user.user.profile.ncsId)}
                getNotifications={getNcsNotificationsList}
                getNotificationsExist={getNcsNotificationsExist}
                updateNotificationsList={request => updateNotificationsList(user.user.profile.ncsId, request)}
                updateSingleNotification={(notificationId, request) =>
                    updateSingleNotification(user.user.profile.ncsId, notificationId, request)
                }
                updateUserPsw={updateUserPassword}
                updateUserPswStatus={updateUserPswStatus}
                userEditStatus={userEditStatus}
            />
            <SuccessPage editMode={false} redirectPath={"/"} resetUserInfo={resetUserInfo} techUser={false} />
        </>
    );
};

function mapStateToProps(state) {
    return {
        auth: state.auth,
        notificationsExist: state.ncs.notifications.exist,
        notificationsList: state.ncs.notifications.data,
        notificationsListStatus: state.ncs.notifications.status,
        user: state.user,
        updateUserPswStatus: state.password.update.status || {},
        userEditStatus: state.manageUser.editUser.status || {}
    };
}

const mapDispatchToProps = {
    logout,
    resetUserInfo,
    editUser,
    deleteSingleNotification,
    deleteNotificationsList,
    getNotificationsList,
    getNotificationsStatus,
    updateSingleNotification,
    updateNotificationsList,
    loadUser,
    updateUserPassword
};

const composedHoc = compose(errorBoundary, connect(mapStateToProps, mapDispatchToProps));

export default composedHoc(MulticompanyCreateUserSuccessView);
